import { render, staticRenderFns } from "./PassagesDetailsCard.vue?vue&type=template&id=a1a35eb0"
import script from "./PassagesDetailsCard.vue?vue&type=script&lang=js"
export * from "./PassagesDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./PassagesDetailsCard.vue?vue&type=style&index=0&id=a1a35eb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports